import { Component, ViewContainerRef } from '@angular/core';
import { Router } from '@angular/router';
import { GeographyMasterService } from '../geography_master.service';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Observable } from 'rxjs/Observable';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';

@Component({
    selector: 'region-master',
    templateUrl: './region_master.component.html'
})
export class regionMaster {

    collectionDetails = [];
    searchDataPafing = [];

    indexStart = 0;
    indexEnd = 10;
    pageSize = 5;
    pageNo = 1;
    totalPage = [1];

    searchInput = '';
    IsRecordUpdated = false;

    CountryId = '';
    code = '';
    name = '';
    ButtonValue = 'Save';
    viewMode = false;
    CreatedBy = '';
    IsDeleting = false;
    DeletedIndex = '';
    createdDate = '';
    country: any;
    regionId = '';

    countryArray = [];


    constructor(private router: Router,
        public toastr: ToastsManager, vcr: ViewContainerRef,
        private PaymentService: GeographyMasterService,
        private fb: FormBuilder) {

        this.toastr.setRootViewContainerRef(vcr);
        this.PaymentService.GetCountryList('')
            .subscribe(departmentListData => {
                this.countryArray = departmentListData;
            });


        this.PaymentService.GetRegionList('')
            .subscribe(departmentListData => {
                this.collectionDetails = [];
                this.searchDataPafing = [];
                this.collectionDetails = departmentListData;
                if (this.collectionDetails.length > 5) {
                    let j = 1;
                    for (var i = 0; i < this.collectionDetails.length; i++) {
                        i = i + this.pageSize;
                        j = j + 1;
                        this.totalPage.push(j);
                    }
                }
                for (var i = 0; i < this.collectionDetails.length; i++) {
                    let arr = [];
                    arr = this.collectionDetails[i];
                    let rowNum = i;
                    this.searchDataPafing.push({ arr, "row": rowNum });
                }
                this.indexStart = 0;//((this.pageNo - 1) * this.pageSize) + 1;
                this.indexEnd = (this.pageNo * this.pageSize);
            });
    }


    pagingAgent(data) {
        this.pageNo = data;
        this.indexStart = (this.pageNo - 1) * this.pageSize + 1;
        this.indexEnd = (this.pageNo) * this.pageSize;
    }

    changeItemsPerPage(data) {
        if (this.collectionDetails.length > 0) {
            this.totalPage = [1]
            let j = 1;
            for (var i = 0; i < this.collectionDetails.length; i++) {
                i = i + this.pageSize;
                j = j + 1;
                this.totalPage.push(j);
            }
        }
        else {
            this.totalPage = [];
        }
        this.pageSize = data;
        this.indexStart = 0;
        this.indexEnd = this.pageSize;
    }

    searchInputFunction() {
        this.PaymentService.GetRegionList(this.searchInput)
            .subscribe(departmentListData => {
                this.collectionDetails = [];
                this.searchDataPafing = [];
                this.collectionDetails = departmentListData;
                console.log("data", departmentListData);
                if (this.collectionDetails.length > 5) {
                    let j = 1;
                    for (var i = 0; i < this.collectionDetails.length; i++) {
                        i = i + this.pageSize;
                        j = j + 1;
                        this.totalPage.push(j);
                    }
                }
                for (var i = 0; i < this.collectionDetails.length; i++) {
                    let arr = [];
                    arr = this.collectionDetails[i];
                    let rowNum = i;
                    this.searchDataPafing.push({ arr, "row": rowNum });
                }

                this.indexStart = 0;//((this.pageNo - 1) * this.pageSize) + 1;
                this.indexEnd = (this.pageNo * this.pageSize);
            });
    }

    UpdateRecordsPopulate(obj) {
        this.viewMode = false;
        this.code = obj["code"];
        this.name = obj["name"];
        this.CountryId = obj["countryId"];
        this.createdDate = obj['createdDate'];
        this.ButtonValue = 'Update';
        this.country = obj['country'];
        this.regionId = obj['id'];
    }

    ViewRecordsPopulate(obj) {
        this.viewMode = true;
        this.code = obj["code"];
        this.name = obj["name"];
        this.IsRecordUpdated = true;
        this.ButtonValue = 'Save';
        this.CountryId = obj["countryId"];
        this.regionId = obj['id'];
    }
    
    reset() {
        this.viewMode = false;
        this.code = '';
        this.name = '';
        this.ButtonValue = 'Save';
        this.CountryId = '';
        this.regionId = '';
    }

    memberFormSubmit() {
        if (this.regionId != '') {
            let data = {
                "code": this.code,
                "country": this.country,
                "countryId": this.CountryId,
                "name": this.name,
                "createdBy": this.CreatedBy,
                "createdDate": this.createdDate,
                "id": this.regionId,
                "isDeleted": false,
                "lastModifiedBy": "",
                "lastModifiedDate": "2017-06-16T11:33:47.887",//new Date(),
                'pinCodeId': []
            }
            this.PaymentService.EditRegion(data)
                .subscribe(departmentListData => {
                    if (departmentListData == "Success") {
                        this.toastr.success("Record updated succesfuly.");
                        this.LoadGrid();
                    }
                    else {
                        this.toastr.error("Something went wrong.");
                    }
                });
        }
        else {
            let data = {
                "code": this.code,
                "name": this.name,
                'countryId': this.CountryId
            }
            this.PaymentService.CreateRegion(data)
                .subscribe(departmentListData => {
                    if (departmentListData == "Success") {
                        this.toastr.success("Record Added succesfuly.");
                        this.LoadGrid();
                    }
                    else {
                        this.toastr.error("Something went wrong.");
                    }
                });
        }
    }

    codegen() {
    }

    deleteProdutConfirm(id, i) {
        this.CountryId = id;
        this.IsDeleting = true;
        this.DeletedIndex = i;
    }
    delete() {
        let data = {
            "id": this.CountryId,
            "trackingState": this.DeletedIndex
        }
        // this.PaymentService.DeleteProductGroup(data)
        //     .subscribe(departmentListData => {

        //     });
    }
    deleteCancel() {
        this.IsDeleting = false;
        this.CountryId = '';
        this.DeletedIndex = '';
    }

    LoadGrid() {
        this.PaymentService.GetRegionList(this.searchInput)
            .subscribe(departmentListData => {
                this.collectionDetails = [];
                this.searchDataPafing = [];
                this.collectionDetails = departmentListData;
                console.log("data", departmentListData);
                if (this.collectionDetails.length > 5) {
                    let j = 1;
                    for (var i = 0; i < this.collectionDetails.length; i++) {
                        i = i + this.pageSize;
                        j = j + 1;
                        this.totalPage.push(j);
                    }
                }
                for (var i = 0; i < this.collectionDetails.length; i++) {
                    let arr = [];
                    arr = this.collectionDetails[i];
                    let rowNum = i;
                    this.searchDataPafing.push({ arr, "row": rowNum });
                }

                this.indexStart = 0;//((this.pageNo - 1) * this.pageSize) + 1;
                this.indexEnd = (this.pageNo * this.pageSize);
            });
    }
}



// WEBPACK FOOTER //
// ./src/app/system_setting/geography_master/region_master/region_master.component.ts